// Vendors
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
// Contexts
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Event Handlers
import { LandingOptionsHandlers } from 'components/landing-options/handlers/landing-options.handlers';
// Types
import {
  LandingOptionsHookReturnType,
  LandingOptionsHookType,
} from 'components/landing-options/hooks/types/landing-options.hook.type';

const useLandingOptionsHook = <T>({
  selectedMethod,
  modalConfiguration,
}: LandingOptionsHookType<T>): LandingOptionsHookReturnType<T> => {
  const [showMethodModal, setShowMethodModal] = useState<boolean>(false);

  const { formatMessage } = useIntl();

  const { setMainButtonConfiguration, flowApiData } = useLayoutContextConsumerHook(),
    { methods = [] } = flowApiData || {};

  const { handleSetupLandingOptionsLayoutButtonConfiguration, ...restHandlers } =
    LandingOptionsHandlers<T>({
      formatMessage,
      modalConfiguration,
      selectedMethod,
      setMainButtonConfiguration,
      setShowMethodModal,
    });

  useEffect(() => {
    handleSetupLandingOptionsLayoutButtonConfiguration();
  }, [selectedMethod]);

  return {
    ...restHandlers,
    formatMessage,
    methods,
    showMethodModal,
  };
};

export { useLandingOptionsHook };
